import { render, staticRenderFns } from "./SideBarMenu.vue?vue&type=template&id=20dc32e5&scoped=true&"
import script from "./SideBarMenu.vue?vue&type=script&lang=js&"
export * from "./SideBarMenu.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=20dc32e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc32e5",
  null
  
)

export default component.exports